import { CURRENCY_SYMBOLS } from '@savgroup-front-common/constants';
import { ReverseMoney } from '@savgroup-front-common/types';

import { formatAmountToString } from './formatAmount';

const formatReverseMoneyToLabel = (
  reverseMoney?: ReverseMoney,
): string | undefined => {
  if (!reverseMoney) {
    return reverseMoney;
  }

  return `${formatAmountToString(reverseMoney.amount)} ${
    CURRENCY_SYMBOLS[reverseMoney.currency]
  }`;
};

export default formatReverseMoneyToLabel;
